import { InputField } from "@/components/common/input";
import { NoteIcon } from "@/components/common/icons/NoteIcon";
import {
  phoneField,
  emailField,
  firstNameField,
  secondNameField,
} from "@/pages/quiz/base/questions/contactField/validationRules";
import { EMAIL_OR_PHONE_TAKEN_ERROR_MESSAGE } from "@/constants";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { useManageInputFields } from "@/pages/quiz/hooks/useManageInputFields";
import { Button, ButtonType } from "@/components/common/button";

export type FormFieldName = "firstName" | "secondName" | "phone" | "email";

type ContactFieldsValues = Record<FormFieldName, string>;

// Define the validation fields and their properties
const validationFields = {
  phone: phoneField,
  email: emailField,
  firstName: firstNameField,
  secondName: secondNameField,
};

const ContactsFieldsCPA = ({
  questionValue,
  setQuestionValue,
  setQuestionAnswer,
}: QuizQuestionProps<ContactFieldsValues>) => {
  const { registerField, error, setFieldError } = useManageInputFields(
    {
      setQuestionValue,
      questionValue,
    },
    validationFields // Pass only the relevant validation fields
  );

  const isAllAnswered =
    Object.values(questionValue).filter(Boolean).length === 4;

  const isNoErrors = Object.values(error).every(
    (errorMessage) => !errorMessage
  );

  const isFormAnswered = isAllAnswered && isNoErrors;

  const onSubmit = async () => {
    if (isFormAnswered) {
      const serverErrors = await setQuestionAnswer({
        ...questionValue,
        email: questionValue.email.toLowerCase(),
      }, true);

      if (serverErrors?.serverError?.status === 409) {
        setFieldError("email", EMAIL_OR_PHONE_TAKEN_ERROR_MESSAGE);
      }
    }
  };

  return (
    <>
      <div className=" flex flex-col-reverse items-center	 w-full justify-center gap-4 desktop:p-8">
        <div className="text-center max-w-[100%] w-[480px] flex-col flex gap-2">
          <h4 className="text-center uppercase section-title xs:text-2xl text-xl">
            You're Pre-Approved!
          </h4>
          <p className="section-title !text-[17px]">
            <NoteIcon />
            Last Step: Please fill out the info below to view your results
          </p>
          <div className="flex direction-row gap-5 ">
            <InputField
              {...registerField("firstName")}
              label="First Name"
              required
            />
            <InputField {...registerField("secondName")} label="Last Name" />
          </div>
          <InputField {...registerField("phone")} label="Phone" type="phone" />
          <InputField {...registerField("email")} label="Email" />
        </div>
      </div>
      <div className="renderer-core-field-action is-visible mt-[28px]">
        <Button
          type={ButtonType.SUBMIT}
          disabled={!isFormAnswered}
          onClick={onSubmit}
        />
      </div>
    </>
  );
};

export { ContactsFieldsCPA };
